import { Col, Modal, Row } from 'antd'
import Button from 'components/Button'
import Flex from 'components/Flex'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import { FooterFlex } from 'modules/Drives/DownloadAndUpload/DownloadCandidateDrawer/style'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import SuccessMessage from 'utils/SuccessMessage'
import { downloadAttachment } from 'utils/downloadAttachment'
import { exportCandidateQuestionnier } from '../../../../../../actions'
import { CardText, CardsFlex1 } from './style'

export const FlexWrapRole = styled(Flex)`
  width: ${props => (props.width ? props.width : '100%')};
  gap: ${props => (props.gap ? props.gap : '0')};
`
const mapArray = [
  {
    name: 'CANDIDATE NAME',
    key: 'candidateName',
  },
  {
    name: 'COLLEGE NAME',
    key: 'collegeName',
  },
  {
    name: 'LOCATION',
    key: 'location',
  },
  {
    name: 'DEG & DEPT',
    key: 'degreeDept',
  },
  {
    name: 'CANDIDATE RATING',
    key: 'rank',
  },
  {
    name: 'QUESTIONNAIRE QUESTIONS',
    key: 'qualifyingQuestions',
  },
]

const mapExperienceArray = [
  {
    name: 'CANDIDATE NAME',
    key: 'candidateName',
  },
  {
    name: 'MOBILE NUMBER',
    key: 'mobileNumber',
  },
  {
    name: 'LATEST COMPANY',
    key: 'companyName',
  },
  {
    name: 'LATEST ROLE',
    key: 'role',
  },
  {
    name: 'LOCATION',
    key: 'location',
  },
  {
    name: 'YEARS OF EXPERIENCE',
    key: 'yearsOfExperience',
  },
  {
    name: 'CANDIDATE RATING',
    key: 'rank',
  },
  {
    name: 'QUESTIONNAIRE QUESTIONS',
    key: 'qualifyingQuestions',
  },
]
const QuestionnaireExport = ({
  exportVisible,
  onHanldleCloseModal,
  exportCard,
  setExportCard,
  singleRoleData,
  candidateStatus,
}) => {
  const dispatch = useDispatch()
  const params = useParams()

  const filteredMapArray =
    singleRoleData?.jobTypeLevels?.[0] === 'EXPERIENCED'
      ? mapExperienceArray?.filter(item => item !== null)
      : mapArray?.filter(item => item !== null)

  const onDownload = async () => {
    let flag = singleRoleData?.jobTypeLevels?.[0] === 'EXPERIENCED'
    dispatch(
      exportCandidateQuestionnier(
        params?.jobId,
        exportCard,
        flag,
        candidateStatus
      )
    )
      .then(response => {
        if (response?.status >= 200 && response?.status <= 300) {
          downloadAttachment(response?.data?.data?.url)
          SuccessMessage('Candidate list downloaded successfully!')
        } else {
          ErrorMessage(response?.response?.data?.message)
        }
      })
      .catch(err => {})
  }

  const footer = () => {
    return (
      <FooterFlex center>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            onHanldleCloseModal()
          }}
        />
        <Button.Primary onClick={onDownload} text={'Export'} />
      </FooterFlex>
    )
  }

  const CardClick = cardId => {
    setExportCard(prev => {
      if (prev?.includes(cardId)) {
        return prev.filter(id => id !== cardId)
      } else {
        return [...prev, cardId]
      }
    })
  }

  return (
    <Modal
      open={exportVisible}
      centered // This prop centers the modal vertically and horizontally
      footer={footer()} // Hide the default footer
      maskClosable={false} // Prevent closing the modal when clicking outside
      closable={false} // Hide the close button
      bodyStyle={{
        borderRadius: '20px',
        padding: '32px 20px 32px 20px',
        textAlign: 'center',
      }}
      width={715}
    >
      <Flex column>
        <div
          style={{
            fontWeight: 700,
            lineHeight: '25px',
            fontSize: '17px',
            color: '#010E30',
            marginBottom: '20px',
          }}
        >
          {'Export titles to Excel'}
        </div>
        <br />

        <Row gutter={20} style={{ rowGap: '24px' }}>
          {filteredMapArray?.map((item, index) => (
            <Col key={item?.key + index} span={8}>
              <CardsFlex1
                column
                onClick={() => {
                  if (item.key === 'candidateName') {
                    return
                  }
                  CardClick(item?.key)
                }}
                isSelected={exportCard?.includes(item?.key)}
                style={{
                  border:
                    exportCard?.includes(item?.key) ||
                    item.key === 'candidateName'
                      ? '1px solid #3249D7'
                      : `1px solid #DBDBDB`,
                  cursor: item.key === 'candidateName' ? 'default' : 'pointer',
                }}
              >
                <CardText
                  style={{
                    color: exportCard?.includes(item?.key)
                      ? '#3249D7'
                      : item.key === 'candidateName'
                      ? '#3249D7'
                      : '#4B465C',
                    wordSpacing:
                      item.key === 'qualifyingQuestions' ? '0.1em' : '0.3em',
                  }}
                >
                  {item?.name}
                </CardText>
              </CardsFlex1>
            </Col>
          ))}
        </Row>
      </Flex>
    </Modal>
  )
}

export default QuestionnaireExport
